export default __webpack_public_path__ + "static/media/circle_profile.b72aca92.png";